import { PaginationInfinityBrowser } from "../pagination/paginationInfinityBrowser";
import { MediaImage } from "../media/mediaImage";
import { template } from "underscore";
import Swiper from "swiper";


export class PageViews {
    // stop faster scrolling
    isLoaded = true;

    isSlider = false;

    swipers = [];
    adsTop = 0;

    viewDataTPL = '<div class="page-view--data" />';

    adTPL = template([
        '<div class="ad-holder">',
        '<div class="ad">',
        '<script type="application/javascript" src="//ced.sascdn.com/tag/1999/smart.js" async></script>',
        '<div id="sas_<%= tagId %>"></div>',
        '<script type="application/javascript">',
        'var sas = sas || {};',
        'sas.cmd = sas.cmd || [];',
        'sas.cmd.push(',
        'function () {',
        'sas.call(',
        '{ siteId: 116373, pageId: 694970, formatId: "<%= tagId %>", tagId: "sas_<%= tagId %>" },',
        '{ networkId: 1999, domain: "//www8.smartadserver.com" /*, onNoad: function() {} */ }',
        ');',
        '}',
        ');',
        '</script>',
        '</div>',
        '</div>'
    ].join(''));

    // staff
    events;

    window = $(window);
    tool;
    structures;
    viewData;

    buttonPattern = /page-view-tool__button--([\-\w]+)/g;

    cardTPL = template([
        '<article class="card-news <%= card.class %>">',
        '<% if (card.image) { %>',
        '<div class="card-news__media">',
        '<figure class="media-image">',
        '<img class="photo" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" width="720" height="405" alt="<%= card.image.alt %>" data-src="<%= card.image.src %>" >',
        '<% if (card.image.mediaInfo) { %>',
        '<% if (card.image.mediaInfo === "PGL") { %>',
        '<i class="media-info media-info--gallery"></i>',
        '<% } %>',
        '<% if (card.image.mediaInfo === "VID") { %>',
        '<i class="media-info media-info--video"></i>',
        '<% } %>',
        '<% } %>',
        '<a class="oop-link" href="<%= card.image.href %>" title="<%= card.image.title %>"><%= card.image.text %></a>',
        '</figure>',
        '</div>',
        '<% } %>',
        '<div class="card-news__body">',
        '<time class="card__dateline"><%= card.publicationDate %></time>',
        '<h3 class="card__heading">',
        '<a class="lnk" href="<%= card.title.href %>" title="<%= card.title.title %>"><%= card.title.text %></a>',
        '</h3>',
        '</div>',
        '</article>'
    ].join(''));


    constructor() {
        this.init();
    }

    init() {
        this.structures = $('.page-view');
        if (!this.structures.length) {
            return;
        }

        this.tool = $('.page-view-tool');

        this.set();
        this.bindEvents();
    }

    set() {
        const defaultOptions = {
            wrapperClass: 'page-view__content',
            slideClass: this.getItemClass()
        };

        this.getSlider(this.structures, defaultOptions);

        this.viewData = $(this.viewDataTPL).insertAfter(this.structures);
    }

    bindEvents() {
        const paginationInfinityBrowser = new PaginationInfinityBrowser();

        this.events = paginationInfinityBrowser.getEvents();

        this.window.on(this.events.browse, () => this.onBrowse());
        this.tool.on('click', 'button', (e) => this.onClick(e));
    }

    onBrowse() {
        if (this.isLoaded && !this.isSlider) {
            this.loadCards($('.pagination-infinity-browser__button'));
        }
    }

    onClick(e) {
        e.preventDefault();

        const button = $(e.target);

        if (button.is('.page-view-tool__button--active')) {
            return;
        }

        const lastActiveViewClass = this.tool.find('.page-view-tool__button--active')
            .removeClass('page-view-tool__button--active')
            .prop('class').match(this.buttonPattern)[0]
            .replace('page-view-tool__button', 'page-view');

        const activeViewClass = button
            .prop('class').match(this.buttonPattern)[0]
            .replace('page-view-tool__button', 'page-view');

        // set slider
        if (activeViewClass === 'page-view--slider') {

            this.loadCards($('.pagination-infinity-browser__button'));
            const defaultOptions = {
                containerClass: 'slider',
                wrapperClass: 'slider__wrapper',
                slideClass: 'slider__slide',
                slideActiveClass: 'slider__slide--active',
                navigation: {
                    prevEl: '.slider__button--prev',
                    nextEl: '.slider__button--next'
                },
                disabledClass: 'slider__button--disabled',
                hiddenClass: 'slider__button--hidden',
                initialSlide: 0,
                a11y: false,
                touchEventsTarget: 'wrapper',
                pagination: {
                    el: '.swiper-pagination__page',
                    dynamicBullets: false,
                },
            };

            const swiper = new Swiper(this.structures, defaultOptions);
            this.swipers.push(swiper);
            $(window).trigger('page-slider-view', {
                target: this.swipers[0]
            });
            this.isSlider = true;
        } else {
            if (this.swipers.length) {
                this.swipers.pop().destroy();
            }

            this.isSlider = false;
        }

        this.structures
            .removeClass(lastActiveViewClass)
            .addClass(activeViewClass);

        this.update();

        button.addClass('page-view-tool__button--active');
    }

    loadCards(browser) {
        const href = browser.data('href');
        const container = $('#' + browser.data('container'));

        container.addClass('page-view__content--loading');
        this.adsTop = container.outerHeight();

        this.isLoaded = false;

        this.sendGAEvent('ScrollView', href);

        $.ajax({
            url: href,
            method: 'GET',
            data: {
                fragment: true
            }
        })
            .done((res) => {

                if (typeof res === "string") {
                    res = JSON.parse(res);
                }

                if ( (res.errors === undefined) || ( (res.errors !== undefined) && res.errors.length ) ) {
                    this.showErrorMessage(container, res.errors);
                    return;
                }

                location.hash = 'page=' + res.data.page;

                // ----------------------
                // ¡mayday! refactor 'TMDAPIContentCardsJSONPage'
                // for CardsCollection scripts
                let html = res.data.html;
                if (this.structures.is('.page-view--module')) {
                    html = this.getCardHTML(res);
                }
                // ----------------------

                container.append(this.getAdvertisingHTML(res), html);

                if (this.swipers.length) {
                    this.swipers[0].update();
                }

                this.loadImages();

                if (!res.data.nextPageUrl) {
                    browser.remove();
                } else {
                    browser.data('href', res.data.nextPageUrl);
                    this.isLoaded = true;
                }
            })
            .fail((err) => {
                this.showErrorMessage(container, err);
            })
            .always(() => {
                if (!container.is('.page-view__content--error')) {
                    container.removeClass('page-view__content--loading');
                }
            });
    }

    getAdvertisingHTML(res) {
        let html = '';
        const tagId = res.data.advertisingConfig.tagId;

        if (tagId) {
            html += '<div class="slider__slide slider__slide--ads" style="top:' + this.adsTop + 'px">' + this.adTPL({ tagId: tagId }) + '</div>';
        }

        return html;
    }

    getCardHTML(res) {
        let html = '';

        const cards = res.data.cards;

        const len = cards.length;
        let i = 0;
        while (i++ < len) {
            const card = cards[i - 1];

            card.class = 'card-news';

            if (card.publicationDate) {
                card.publicationDate = this.formatDate(card.publicationDate);
            }

            html += '<div class="slider__slide">'+ this.cardTPL({ card: card }) +'</div>';
        }

        return html;
    }

    formatDate(date) {
        return new Date(date).toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }

    showErrorMessage(container, err) {
        console.error('Error on "pageViews" ', err);
        container.addClass('page-view__content--error');
    }

    loadImages() {
        new MediaImage();
    }

    getItemClass() {
        return this.structures.find('.page-view__content').children().attr('class').split(' ')[0] || '';
    }

    update() {
        this.updateTopAds();
    }

    updateTopAds() {
        const ads = $('.slider__slide--ads');
        if (ads.length) {
            $('.slider__slide--ad-seed').each((index, adSeed) => {
                ads.eq(index).css('top', adSeed.getBoundingClientRect().top);
            });
        }
    }

    sendGAEvent(action, value) {
        if (typeof ga !== "undefined") {
            ga(function () {
                const trackers = ga.getAll();
                trackers.forEach(function(tracker) {
                    // log tracker info
                    console.debug(
                        tracker.get("name") + " - " + "trackingId: " + tracker.get("trackingId") + " - clientId: " + tracker.get("clientId")
                    );
                    // send pageview to defined tracker
                    ga( tracker.get("name") + ".send", "pageview", value );
                });
            });
        }
    }

    getSlider(slider, options) {
        const defaultOptions = {
            containerClass: 'slider',
            wrapperClass: 'slider__wrapper',
            slideClass: 'slider__slide',
            navigation: {
                prevEl: '.slider__button--prev',
                nextEl: '.slider__button--next'
            },
        };

        let scrollable = $();
        let root;
        let slides;
        let wrapper;
        let navigation;

        let paginationEl = options.pagination && options.pagination.el || '';
        let prevEl = (options.navigation && options.navigation.prevEl) || defaultOptions.navigation.prevEl;
        let nextEl = (options.navigation && options.navigation.nextEl) || defaultOptions.navigation.nextEl;

        slider.each((index, el) => {
            root = $(el).addClass(defaultOptions.containerClass);

            // get or create slides
            slides = root.find('.' + defaultOptions.slideClass).length ||
                root
                    .find('.' + options.slideClass)
                    .wrap('<div class="' + defaultOptions.slideClass + '"/>')
                    .parent('.' + defaultOptions.slideClass);

            // get or create wrapper
            wrapper = root.find('.' + defaultOptions.wrapperClass).length ||
                root.find('.' + options.wrapperClass).addClass(defaultOptions.wrapperClass).length ||
                slides
                    .wrapAll('<div class="' + defaultOptions.wrapperClass + '"/>')
                    .closest('.' + defaultOptions.wrapperClass);

            scrollable = scrollable.add(root.filter('.' + defaultOptions.containerClass));

            // get or create navigation
            navigation = root.find([prevEl, nextEl].toString()).length || slides.length > 1 &&
                $('<a class="' + prevEl.replace('.', '') + '" /><a class="' + nextEl.replace('.', '') + '" />')
                    .appendTo(scrollable.eq(index));

            // remove pagination
            if (slides.length === 1) {
                root.find(paginationEl).remove();
            }
        });

        // release
        root = wrapper = slides = navigation = prevEl = nextEl = paginationEl = null;

        return scrollable;
    }
}
